export default function ServiziHero() {
  return (
    <section className="relative min-h-[60vh] sm:min-h-[70vh] lg:min-h-[80vh] flex items-center justify-center overflow-hidden">
      <div
        className="absolute inset-0 bg-cover bg-center"
        style={{
          backgroundImage:
            'url(https://public.readdy.ai/ai/img_res/c4fff6465934549496aea5e624f64573.jpg)',
        }}
      ></div>
      <div className="absolute inset-0 bg-gradient-to-b from-[#0B1F3B]/80 via-[#0B1F3B]/75 to-[#0B1F3B]/80"></div>

      <div className="relative z-10 max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12 sm:py-16 lg:py-20 text-left">
        <h1 className="font-serif text-3xl sm:text-4xl md:text-5xl lg:text-6xl xl:text-7xl font-bold text-white mb-4 sm:mb-6 lg:mb-8 leading-tight">
          I Nostri Servizi
        </h1>
        <p className="text-base sm:text-lg lg:text-xl xl:text-2xl text-white/90 max-w-4xl font-light leading-relaxed">
          Soluzioni professionali per la valutazione e valorizzazione del patrimonio aziendale
        </p>
      </div>
    </section>
  );
}
